import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';

type Params = {
  disableSuccessAlert?: boolean;
};

type Req = {
  contactId: number;
  customerId: number;
};

type Return = {
  deleteCustomerContact: (req: Req) => Promise<void>;
  isDeleting: boolean;
  isErrorDeleting: boolean;
};

export const useDeleteCustomerContact = (params?: Params): Return => {
  const { customersApi } = useApiClient();

  const { isError, isPending, mutateAsync } = useMutation<void, AxiosError, Req>({
    meta: { disableSuccessAlert: params?.disableSuccessAlert },
    mutationFn: async req => {
      await customersApi.deleteCustomerContact(req.customerId, req.contactId);
    },
  });

  return {
    deleteCustomerContact: mutateAsync,
    isDeleting: isPending,
    isErrorDeleting: isError,
  };
};
